import { supabase } from '../../lib/supabase';
import type { Story, Profile, Band } from '../../types/database';

export type StoryWithDetails = Story & {
  author: Profile;
  band: Band;
  likes_count: number;
};

export async function fetchStories(
  page: number,
  itemsPerPage: number,
  searchQuery?: string,
  selectedBand?: string | null
) {
  try {
    let query = supabase
      .from('stories')
      .select(`
        *,
        author:profiles!stories_author_id_fkey(*),
        band:bands!stories_band_id_fkey(*)
      `, { count: 'exact' });

    // Add search filter
    if (searchQuery && searchQuery.trim() !== '') {
      query = query.or(`title.ilike.%${searchQuery.trim()}%,content.ilike.%${searchQuery.trim()}%`);
    }

    // Add band filter
    if (selectedBand) {
      query = query.eq('band_id', selectedBand);
    }

    const start = page * itemsPerPage;
    query = query
      .range(start, start + itemsPerPage - 1)
      .order('created_at', { ascending: false });

    const { data: storiesData, count, error } = await query;

    if (error) throw error;

    // Get likes count for each story
    const storiesWithLikes = await Promise.all(
      (storiesData || []).map(async (story) => {
        const { count: likesCount } = await supabase
          .from('story_likes')
          .select('*', { count: 'exact' })
          .eq('story_id', story.id);

        return {
          ...story,
          likes_count: likesCount || 0,
        };
      })
    );

    return { stories: storiesWithLikes, totalCount: count };
  } catch (error) {
    console.error('Error fetching stories:', error);
    throw error;
  }
}

export async function fetchBands() {
  try {
    const { data, error } = await supabase
      .from('bands')
      .select('*')
      .order('name');

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching bands:', error);
    throw error;
  }
}